<template>
  <v-row class="ma-2" justify="center">
    <v-col cols="12">
      <v-card
          class="mx-auto text--white"
          color="#fafafa"
          max-width="700"
      >
        <v-card-title>
          <p class="text-h4 text--primary">
            Welcome to Extreme Backlink
          </p>
        </v-card-title>

        <v-card-text class="text-h5 font-weight-bold">
          {{aboutExtremeBacklink}}
        </v-card-text>

        <v-card-actions>
          <v-list-item class="grow">
            <v-row
                align="center"
                justify="end"
            >
              <social-icon v-for="(item, key) in socialData" :link="item.link" :icon="item.icon" :key="key"/>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import SocialIcon from "../components/buttons/SocialIcon";
export default {
  name: "Home",
  components: {SocialIcon},
  data() {
    return {
      socialData: [
        {
          icon: 'mdi-facebook',
          link: '#'
        },
        {
          icon: 'mdi-youtube',
          link: '#'
        },
        {
          icon: 'mdi-linkedin',
          link: '#'
        },
        {
          icon: 'mdi-twitter',
          link: '#'
        }
      ],
      aboutExtremeBacklink: "Your ultimate destination for premium-quality guest posting and link building services.With a team of experienced professionals and a commitment to excellence, we empower businesses to strengthen their online presence, boost organic traffic, and achieve long-term success in the digital landscape."
    }
  }
}
</script>

